import service from '@/utils/server';

const modName = '/mdm/yzCompany/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

//修改方法
export const editData = data => {
  return service({
    url: modName + 'editData',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/mdm/yzCompany/api/index.js